import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { ReceiptService } from "../../services/receipt.service";

import { Receipt } from "../../models/receipt.model";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

import { UserService } from "../../@core/services/user.service";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { DialogPrintReceiptComponent } from "../dialog-print-receipt/dialog-print-receipt.component";
import Shop from "../../models/shop.model";
import { User } from "../../@core/data/users";

@Component({
  selector: "ngx-view-receipt",
  styleUrls: ["./view-receipt.component.scss"],
  templateUrl: "./view-receipt.component.html",
})
export class ViewReceiptComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop = new Shop();

  @Input() receipt: Receipt;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onClosed: EventEmitter<any> = new EventEmitter();

  @Input() mode?: string = ""; //home / receipt / detail

  isMore? = false;
  loading = false;
  submitted = false;
  view = "main";
  uid = "";
  isMobile = false;
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];
  user?: User;

  constructor(
    public userService: UserService,
    private receiptService: ReceiptService,
    private dialogService: NbDialogService,
    private router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService,
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    if (this.mode !== "report") {
      this.isMore = true;
    }

    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.receipt.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$),
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });

    console.log("ViewReceiptComponent/ngOnInit:", this.receipt);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadContent() {
    this.isMore = !this.isMore;
  }

  loadButtonAction(item) {
    this.menuItems = [
      { title: "Sửa", icon: "edit-2-outline", data: item },
      { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
      {
        title: "Chi tiết",
        icon: "external-link-outline",
        link: `/receipt/${this.receipt.id}`,
      },
    ];
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.receiptService.delete(this.shopId, item.id).subscribe(
            (result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            },
            (error) => {
              this.loading = false;
              this.submitted = false;
            },
          );
        }
      });
  }

  edit(item: Receipt) {
    this.onClosed.emit(item.id);
    const preUrl = item.isTrade ? "trade" : "receipt";
    this.router.navigateByUrl(`/${preUrl}/${item.id}`);
  }

  unlockReceipt(item: Receipt) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: `Xác nhận mở lại phiếu?`,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.receiptService.unlock(this.shopId, item.id).subscribe(
            (data) => {
              this.loading = false;
              this.submitted = false;

              this.onClosed.emit(item.id);
              if (item.isTrade) {
                this.router.navigateByUrl("/trade/" + item.id);
              } else {
                this.router.navigateByUrl("/receipt/" + item.id);
              }
            },
            (err) => {
              this.loading = false;
              this.submitted = false;

              this.messageErr =
                "Có lỗi trong quá trình mở phiếu, xin vui lòng xác nhận lại";
            },
          );
        }
      });
  }

  closeReceipt(item: Receipt) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: `Xác nhận đóng phiếu?`,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.receiptService.closed(this.shopId, item.id).subscribe(
            (data) => {
              this.loading = false;
              this.submitted = false;
              item.isClosed = true;

              this.onClosed.emit(item.id);
            },
            (err) => {
              this.loading = false;
              this.submitted = false;

              this.messageErr =
                "Có lỗi trong quá trình mở phiếu, xin vui lòng xác nhận lại";
            },
          );
        }
      });
  }

  messageErr = "";
  printReceipt() {
    this.dialogService
      .open(DialogPrintReceiptComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          receipt: this.receipt,
          shop: this.shop,
          rePrint: true,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {
        this.loading = true;
        this.submitted = true;

        this.receipt.noPrint++;
        this.receiptService
          .rePrint(this.shopId, this.receipt.id, this.receipt.noPrint)
          .then((data) => {
            this.loading = false;
            this.submitted = false;

            this.messageErr = "";
          })
          .catch((err) => {
            this.loading = false;
            this.submitted = false;

            this.messageErr = "Xảy ra lỗi trong quá trình in lại";
          });
      });
  }
}
